import axios from 'axios';

import type {
  GetApiV1UsersByIdData,
  GetApiV1UsersByIdEditResponse,
  GetApiV1UsersByIdResponse,
  GetApiV1UsersByUsernameMenteesResponse,
  GetApiV1UsersByUsernameMentorsResponse,
  PostApiV1UsersByUsernameMentorsResponse,
} from '~/api/generated';

type ProfileDateRange = NonNullable<GetApiV1UsersByIdData['query']>;
export type Mentorship = GetApiV1UsersByUsernameMentorsResponse[number];

export async function fetchEditableUser(handle: string): Promise<GetApiV1UsersByIdEditResponse> {
  const { data } = await axios.get<GetApiV1UsersByIdEditResponse>(`/api/v1/users/${handle}/edit`);

  return data;
}

export async function fetchUserProfile(handle: string, params: ProfileDateRange): Promise<GetApiV1UsersByIdResponse> {
  const { data } = await axios.get<GetApiV1UsersByIdResponse>(`/api/v1/users/${handle}`, { params });

  return data;
}

export async function fetchMentors(username: string): Promise<GetApiV1UsersByUsernameMentorsResponse> {
  const { data } = await axios.get<GetApiV1UsersByUsernameMentorsResponse>(`/api/v1/users/${username}/mentors`);

  return data;
}

export async function fetchMentees(username: string): Promise<GetApiV1UsersByUsernameMenteesResponse> {
  const { data } = await axios.get<GetApiV1UsersByUsernameMenteesResponse>(`/api/v1/users/${username}/mentees`);

  return data;
}

export async function addMentor(username: string, mentorUsername: string): Promise<PostApiV1UsersByUsernameMentorsResponse> {
  const { data } = await axios.post<PostApiV1UsersByUsernameMentorsResponse>(
    `/api/v1/users/${username}/mentors`,
    { mentor_username: mentorUsername },
  );

  return data;
}

export async function removeMentor(username: string, mentorId: number): Promise<void> {
  await axios.delete(`/api/v1/users/${username}/mentors/${mentorId}`);
}

export async function setCrowdinUsername(userId: number, crowdinUsername: string): Promise<void> {
  await axios.patch(`/api/v1/users/${userId}/crowdin_username`, { crowdin_username: crowdinUsername });
}
